import React from 'react';
import { object, string } from 'yup';
import { Formik, Form } from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';

import { useHttpStatus, useQuery } from '~/commons/hooks';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';

const schema = object().shape({
  username: string().required().label('email'),
});
const defaults = {
  username: '',
};

const t = {
  en: {
    send: {
      sent: 'Reset password email sent',
      msg: 'Please check your mailbox and follow the instruction to reset your password.',
      confirm: 'Back to Login Page',
    },
    reset: {
      title: 'Forgot your password?',
      expiredTitle: 'Password expired',
      msg: 'Please enter your user name to change your password.',
      btn: 'Send reset email',
      username: 'Username',
    },
  },
  'zh-Hant': {
    send: {
      sent: '重設密碼電子郵件已發送',
      msg: '請檢查您的郵箱並按照指示重設您的密碼。',
      confirm: '返回登入頁面',
    },
    reset: {
      title: '忘記密碼?',
      expiredTitle: '密碼已過期',
      msg: '請輸入您的使用者名稱以變更密碼。',
      btn: '傳送重設密碼電郵',
      username: '使用者名稱',
    },
  },
};

const FormPwdResetMail = ({ expired }) => {
  const [res, req] = useHttpStatus();
  const { lg = 'en' } = useQuery();

  return (
    <>
      {res.status === 'success' ? (
        <div>
          <h2>
            <FA icon={faEnvelope}></FA>
            &nbsp; {t[lg].send.sent}
          </h2>
          <p>
            {t[lg].send.msg}
          </p>
          <br />
          <a className="btn btn-block btn-primary" href="/">
            {t[lg].send.confirm}
          </a>
        </div>
      ) : (
        <Formik
          validationSchema={schema}
          initialValues={defaults}
          onSubmit={(values) => req({
            method: 'post',
            url: '/api/core/pwd-resets',
            data: values,
          })
          }
        >
          <Form>
            <FormHttpAlert res={res} />
            <h2>{expired ? t[lg].reset.expiredTitle : t[lg].reset.title}</h2>
            {t[lg].reset.msg}
            <br />
            <br />
            <FormGroup name="username" label={`${t[lg].reset.username}*`} placeholder={t[lg].reset.username} />
            <div className="form-group text-right">
              <FormHttpBtn
                res={res}
                type="submit"
                className="btn-block btn-primary"
                icon={faPaperPlane}
              >
                {t[lg].reset.btn}
              </FormHttpBtn>
            </div>
          </Form>
        </Formik>
      )}
    </>
  );
};

export default FormPwdResetMail;
